import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { MOBILE_RENDERER_ID, MOBILE_VIEW_ID } from 'crazyEditor/core/constants/editorConstants';
import { elementDefinitions } from 'crazyEditor/components/Elements/index';
import MobileCopyrightAd from 'crazyEditor/components/Ads/FooterAds/MobileCopyrightAd';
import shallowEqual from 'fbjs/lib/shallowEqual';
import { setMobileRefById } from 'crazyEditor/core/elements/utils/elementRefUtils';
import { PAGE_ELEMENT_ID, BACKGROUND_ELEMENT_ID } from 'crazyEditor/core/elements/utils/elementStaticUtils';
import { getElementDefinitionProps } from 'crazyEditor/core/elements/utils/elementDefinitionUtils';
import {renderInFragmentedContainers} from '../common/templateRenderHelpers';

const styles = {
  fontFamily: 'Open Sans'
};

function getStyles(pageElement, viewStyles, desktopPageElement, renderFragmentedContainers) {
  let {fontFamily} = pageElement.compProps;
  if (!fontFamily) {
    fontFamily = desktopPageElement.compProps.fontFamily;
  }
  return {
    width: `${pageElement.layout.width}px`,
    height: renderFragmentedContainers ? 'auto' : `${pageElement.layout.height}px`,
    overflow: 'hidden',
    position: 'relative',
    margin: '0 auto',
    fontFamily,
    ...viewStyles
  };
}

function getCompPropsForPageElement(compProps) {
  return _.pick(compProps, ['backgroundColor', 'backgroundImage']);
}

function getCompPropsForElement(compProps) {
  return _.omit(compProps, 'zIndex');
}

function getCompPropsAndDataFromDesktopElement(desktopElement) {
  const compProps = desktopElement.compProps;
  return {
    compProps: desktopElement.id === PAGE_ELEMENT_ID ? getCompPropsForPageElement(compProps) : getCompPropsForElement(compProps),
    data: desktopElement.data
  };
}

export default class MobileRenderer extends Component {

  shouldComponentUpdate(nextProps) {
    return !shallowEqual(this.props, nextProps);
  }

  renderElement = (mobileElement) => {
    const {desktopElements, staticDesktopElements, publish, isQuickPreviewMode, isPreviewMode} = this.props;
    const desktopElement = mobileElement.id === PAGE_ELEMENT_ID ? staticDesktopElements[PAGE_ELEMENT_ID] : desktopElements[mobileElement.desktopId];

    if (!desktopElement) {
      return null;
    }
    const elementClass = elementDefinitions[mobileElement.type].elementClass;
    const mobileElementProps = {autoHeightTextElement: true};
    _.merge(mobileElementProps, getCompPropsAndDataFromDesktopElement(desktopElement), mobileElement);
    return React.createElement(elementClass, {
      key: mobileElement.id,
      ref: setMobileRefById.bind(null, mobileElement.id),
      definitionProps: getElementDefinitionProps(mobileElement, {publish, isMobile: true}),
      ...mobileElementProps,
      publish,
      isQuickPreviewMode,
      isPreviewMode,
    });
  };

  render() {
    const {
      viewStyles,
      mobileElements,
      staticMobileElements,
      staticDesktopElements,
      showAds,
      publish,
      isPreviewMode,
      } = this.props;
    const renderFragmentedContainers = publish || isPreviewMode;
    const pageElement = staticMobileElements[PAGE_ELEMENT_ID];
    const desktopPageElement = staticDesktopElements[PAGE_ELEMENT_ID];
    const mobileViewStyle = getStyles(pageElement, viewStyles, desktopPageElement, renderFragmentedContainers);
    return (
      <div id={MOBILE_RENDERER_ID} style={styles}>
        <div id={MOBILE_VIEW_ID}
             style={mobileViewStyle}>
          { this.renderElement(pageElement, desktopPageElement, publish) }
          {
            renderFragmentedContainers ?
              renderInFragmentedContainers(mobileElements, pageElement, this.renderElement) :
              _.map(mobileElements, (mobileElement) => {
                if (!mobileElement.parentId) {
                  return this.renderElement(mobileElement);
                }
              })
          }
        </div>
        { showAds &&
        <MobileCopyrightAd
          style={_.pick(mobileViewStyle, ['width', 'margin'])}
        />
        }
      </div>
    );
  }
}

MobileRenderer.propTypes = {
  mobileElements: PropTypes.object.isRequired,
  staticMobileElements: PropTypes.object.isRequired,
  desktopElements: PropTypes.object.isRequired,
  staticDesktopElements: PropTypes.object.isRequired,
  viewStyles: PropTypes.object,
  showAds: PropTypes.bool,
  publish: PropTypes.bool
};

MobileRenderer.defaultProps = {
  viewStyles: {},
  showAds: false
};